import { render, staticRenderFns } from "./QuestionnaireGlossaryItemSelectDialog.vue?vue&type=template&id=185ee242&scoped=true&"
import script from "./QuestionnaireGlossaryItemSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireGlossaryItemSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireGlossaryItemSelectDialog.vue?vue&type=style&index=0&id=185ee242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ee242",
  null
  
)

export default component.exports